import { getDefaultAttributes } from 'core-lib/utils/events';

export const getDefaultAttrs = () => ({
  ...getDefaultAttributes(),
  category: 'Money',
});

export const pageLoaded = {
  name: 'page_loaded',
  attributes: {
    pageName: 'page_name',
  },
};

export const ctaClicked = {
  name: 'cta_clicked',
  attributes: {
    pageName: 'page_name',
    optionSelected: 'option_selected',
  },
};

export const pincodeValidation = {
  name: 'checkbox_clicked',
  attributes: {
    pageName: 'page_name',
    optionSelected: 'option_selected',
    pincode: 'keyword',
  },
};
